
<template>
  <div id="A0" class="sub">
    <div class="wrapper">
      <kg-header :headerType=1 />
      <div class="inner_static">
        <h1 class="tit1">注文完了</h1>
      </div>
      <div class="inner_static">
        <ul class="thanks">
          <li>ご注文ありがとうございました。</li>
          <li>注文完了メールを自動送信しました。</li>
          <li><a @click="goTop">TOPへ戻る</a></li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>

import Header from '../components/common/HomeIconHeader'

import * as App from '../../utils/App'
import {KG_STORAGE_KEY} from '../../constants/App'

export default {
  name: 'orderComplete',
  components: {
    'kg-header': Header
  },
  data () {
    return {
    }
  },
  methods: {
    goTop: function () {
      this.$router.push({
        name: 'KgTop'
      })
    }
  },
  created () {
    App.removeLocalStorage(KG_STORAGE_KEY.SELECT_CATEGORY_DATA)
    App.removeLocalStorage(KG_STORAGE_KEY.SELECT_STYLE_DATA)
    App.removeLocalStorage(KG_STORAGE_KEY.SELECT_PLAN_DATA)
    App.removeLocalStorage(KG_STORAGE_KEY.ORDER_INFO)
    App.removeLocalStorage(KG_STORAGE_KEY.ORDER_INPUT)
    App.removeLocalStorage(KG_STORAGE_KEY.OPTION_SERVICE_LIST)
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/pages/OrderComplete.vue